import {api as axios} from '../shared/axios';
import useSWR from 'swr'
import { API_URL } from '../shared/config';


const fetcher = url => axios.get(url)


//list of all companies
export const useGetCompanies  =() =>{
    const { data, error } = useSWR(`${API_URL}/company/`, fetcher)
    return {
      companies: data?.data,
      isLoadingCompanies: !error && !data,
      isErrorCompanies: error
    }
}
// list of plants (of a company)
export const useGetCompanyPlants  =(company_id) =>{
    const { data, error } = useSWR(`${API_URL}/plant/company/${company_id}/`, fetcher,{
      dedupingInterval: 10000,
      onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
        if (error.status === 404) return // No need to retry 404 errors
        if (error.status === 429) return // No need to retry 429 errors (Too Many Requests error)
        if (retryCount >= 2) return // Only retry up to 2 times.
        // Retry after 20 seconds.
        setTimeout(() => revalidate({ retryCount }), 20000)
      }
    })
    return {
      plants: data?.data,
      isLoadingPlants: !error && !data?.data,
      isErrorPlants: error
    }

}
// list of dashboards (of a plant)
export const useGetPlantDashboards  =(plant_id) =>{
    const { data, error } = useSWR(`${API_URL}/widget/dashboard/plant/${plant_id}/`, fetcher,{
      dedupingInterval: 10000,
      onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
        if (error.status === 404) return // No need to retry 404 errors
        if (error.status === 429) return // No need to retry 429 errors (Too Many Requests error)
        if (retryCount >= 2) return // Only retry up to 2 times.
        // Retry after 20 seconds.
        setTimeout(() => revalidate({ retryCount }), 20000)
      }
    })
    return {
      dashboards: data?.data,
      isLoadingDashboards: !error && !data?.data,
      isErrorDashboards: error
    }
}
//get a dashboard (from plant)
export const useGetPlantDashboardByID  =(dashboard_id) =>{
    // console.log(dashboard_id, "dashboard_id")
    const { data, error } = useSWR(`${API_URL}/widget/dashboard/${dashboard_id}/`, fetcher,{
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateOnMount: true, // If false, undefined data gets cached against the key.
	    dedupingInterval: 9_00_00, // don't duplicate a request with the same key for 1 minute,
      onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
        if (error.status === 404) return // No need to retry 404 errors
        if (error.status === 429) return // No need to retry 429 errors (Too Many Requests error)
        if (retryCount >= 2) return // Only retry up to 2 times.
        // Retry after 20 seconds.
        setTimeout(() => revalidate({ retryCount }), 20000)
      }
    })
    return {
      dashboardData: data?.data,
      isLoadingData: !error && !data?.data,
      isErrorData: error
    }
}














export const getDashboard = async () => {
    try {
        const response = await axios.get(`${API_URL}/widget/dashboard`);
        return response.data
    }
    catch (error) {
        //console.log(error)
    }
}


export const useGetDashboard  =() =>{
    const { data, error } = useSWR(`${API_URL}/widget/dashboard/`, fetcher)

    return {
      dashboard: data?.data,
      isLoadingDashboard: !error && !data,
      isErrorDashboard: error
    }
}
export const useWidgetDashboardByID  =(id) =>{
    const { data, error } = useSWR(`${API_URL}/widget/dashboard/${id}/`, fetcher,{
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateOnMount: true, // If false, undefined data gets cached against the key.
	    dedupingInterval: 9_00_00, // don't duplicate a request with the same key for 1 minute,
    })
    return {
      dashboardData: data?.data,
      isLoadingData: !error && !data?.data,
      isErrorData: error
    }
}

export const useCompanyDashboardByID  =(id) =>{
  const { data, error } = useSWR(`${API_URL}/widget/dashboard/company/${id}/`, fetcher)
  return {
    companyDashboard: data?.data,
    isLoadingCompany: !error && !data?.data,
    isErrorCompany: error
  }
}

export const updateWidgetLayout = async (data,id) => {
    try {
        const request = await axios.patch(`${API_URL}/widget/dashboard/${id}/`, data);
        return { data: request.data, error: undefined };
    } catch (error) {
        return { data: undefined, error: error };
    }
}


export const addNewWidgets = async (widget_detail) => {
  try {
      const request = await axios.post(`${API_URL}/widget/generate/`, widget_detail);
      return { data: request.data, error: undefined };
  } catch (error) {
    
      return { data: undefined, "error": error?.response?.data?.detail };
  }
}

export const editWidgetSetup = async (data,id) => {
    try {
        const response = await axios.patch(`${API_URL}/widget/${id}/`, data);
        // console.log(response)
        if(response?.data){
          return { data: response?.data, error: false };
        }else{
          return { data: null, error: true };
        }
    } catch (error) {
        return { data: null, error: true };
    }
}


export const useWidgetSetupDetails=(id, getDetails) =>{
  const { data, error } = useSWR(getDetails?`${API_URL}/widget/${id}/`:null, fetcher)
  return {
    details: data?.data,
    isLoadingDetails: !error && !data?.data,
    isErrorDetails: error
  }
}

